import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getActiveAudioSchemaDevice } from '../../services/AudioSchemaService';
import { AudioSchemaPerDevice } from '../../types/AudioSchemas';
import { FeaturesManagement } from '../../../featuresControl';

function useGetAudioSchemaDevice(fleetId: string, deviceId: string): UseQueryResult<AudioSchemaPerDevice> {
  return useQuery(
    ['audio-schemas', fleetId, deviceId],
    async (): Promise<AudioSchemaPerDevice> => getActiveAudioSchemaDevice(fleetId, deviceId),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      enabled: fleetId !== '' || deviceId !== '',
      refetchOnWindowFocus: false,
      // refetchInterval: FeaturesManagement.productivity.refetchInterval,
    },
  );
}

export default useGetAudioSchemaDevice;
